"use strict";
exports.__esModule = true;
exports.EMAIL_EVENTS = void 0;
var EMAIL_EVENTS = {
    FINANCIAL_TRANSACTIONS_REQUESTED: 'financial_transactions_requested',
    USER_CREATED: 'user_created',
    USER_INVITATION_CREATED: 'user_invitation_created',
    USER_INVITATION_REINVITED: 'user_invitation_reinvited',
    USER_INVITATION_ACCEPTED: 'user_invitation_accepted',
    APPLICANT_ADDED_TO_LOAN_APPLICATION: 'applicant_added_to_loan_application',
    MORTGAGE_ACCOUNT_CREATED: 'mortgage_account_created',
    MORTGAGE_ACCOUNT_SUSPENDED: 'mortgage_account_suspended',
    CUSTOMER_ADDED_TO_MORTGAGE_ACCOUNT: 'customer_added_to_mortgage_account'
};
exports.EMAIL_EVENTS = EMAIL_EVENTS;
